/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function($) {
	// console.log('jquery IS')


 
  
  
  $('.cb-cmplexity ').find('input[type="radio"]').on('change', function() {
    const optionName = $(this).siblings('label').find('.option-title').text();
    $(this).parents('.radio__fieldset').find('.radio__legend__value').text(optionName);

    let complOptHandle = $(this).data('cb_opt_name');
    let currFieldset = $('.cb-select__fieldset[data-cb_opt_name="' + complOptHandle + '"]');
    if (currFieldset.length > 0) {
      let relatedOptionValueEl = $(currFieldset).find('popout-select li a[data-popout-option][data-value="' + optionName + '"]');
      if (relatedOptionValueEl !== null && relatedOptionValueEl.length > 0) {
        relatedOptionValueEl[0].click();
      }
    }
  });

  $(document).ready(function() {

    setTimeout(function(){
       $('.rps-csb-container').prependTo('.rps-csb-margin-left');
    }, 500)

    if (window.matchMedia("(max-width: 767px)").matches) {
          setTimeout(function(){
           $('#rps_sticky_widget').prependTo('.header__wrapper');
        }, 1000)
    }

    $(".cb-btn-help").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".index-contact").offset().top - 400
        }, 500);
    });

    $('#Rte--template--24937606218016__section_rich_text_tDEdwc .btn').click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".btn[name='add']").offset().top - 200
        }, 500);
    });

    

      setTimeout(function(){
        $('.jdgm-preview-badge--with-link').click(function(){
          console.log('reviews');
           $('.cb-reviews-tab').find('.accordion__title').click();
           $([document.documentElement, document.body]).animate({
              scrollTop: $('.cb-reviews-tab').find('.accordion__title').offset().top - 140
          }, 500);
         
        })
      }, 1000)
   
     
      
    

    
     
    
  });



  
})(jQuery);



      
(function() {
  // Add custom code below this line
  


   const MAX_SIZE_MB = 5;
  const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'application/pdf'];

  const $dropArea = $('#drop-area');
  const $fileInput = $('#fileElem');
  const $message = $('#message');

  function showMessage(msg, isError = true) {
    $message.text(msg).css('color', isError ? 'red' : 'green');
  }

  function validateFile(file) {
    if (!ALLOWED_TYPES.includes(file.type)) {
      showMessage('❌ Unsupported file type: ' + file.type);
      return false;
    }
    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      showMessage('❌ File is too large. Max size is ' + MAX_SIZE_MB + 'MB');
      return false;
    }
    return true;
  }

  async function uploadFile(file) {
    showMessage('⏳ Uploading file...');

    let file_name = file.name;
    let base64file = await toBase64(file);

    fetch('https://alt.cartblender.com/projects/thebathtime-store/upload_file.php', {
      method: 'POST',
      body: JSON.stringify({
        file: base64file,
        file_name,
      })
    }).then(function(resp) {
      if (resp.ok) {
         $('#drop-area').hide();
        showMessage('');
         // $('#drop-area').css('background-image','url("'+ resp.file_url  +'")');
        // console.log(resp);

        $('.cb-file-ready').fadeIn();
        // showMessage('✅ File uploaded successfully!', false)
      } else {
        showMessage('❌ Upload failed')
      }

      return resp.json();
    }).then(function(resp) {
      let file_url = resp.file_url;
      $('#cb-dynamic-options-attached-file').val(file_url);
      let file_name = file_url.split('/');
      file_name = file_name[file_name.length - 1];
      $('.cb-file-ready .cb-file-name').text(file_name.split('?')[0]);
    })
    .catch(() => showMessage('❌ Server connection error'));
    
    //remove file Button
     $('.cb-file-ready').find('.cb-remove-btn').on('click',function(){
       $('#drop-area').show();
       $('.cb-file-ready').fadeOut();
       $('.cb-file-ready').attr('style','display: none !important');
       $('#cb-dynamic-options-attached-file').val('');
     })
  }

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

  function handleFiles(files) {
    const file = files[0];
    if (validateFile(file)) {
      uploadFile(file);
    }
  }

  ['dragenter', 'dragover'].forEach(eventName => {
    $dropArea.on(eventName, function (e) {
      e.preventDefault();
      e.stopPropagation();
      $dropArea.addClass('highlight');
    });
  });

  ['dragleave', 'drop'].forEach(eventName => {
    $dropArea.on(eventName, function (e) {
      e.preventDefault();
      e.stopPropagation();
      $dropArea.removeClass('highlight');
    });
  });

  $dropArea.on('drop', function (e) {
    const dt = e.originalEvent.dataTransfer;
    const files = dt.files;
    handleFiles(files);
  });

  $('#browse-trigger').on('click', function () {
    $fileInput.click();
  });

  $fileInput.on('change', function () {
    handleFiles(this.files);
  });


  
function cleanTextWithoutParentheses(selector = '.option-title') {
  const elements = document.querySelectorAll(selector);

  elements.forEach(el => {
    const text = el.textContent;
    const cleaned = text.replace(/\s*\(.*?\)/g, '').trim(); // видаляє текст у дужках з пробілом перед ними
    el.textContent = cleaned;
  });
}

  
  cleanTextWithoutParentheses();

  // Update cart drawer and header icon when a product is added to cart
  document.addEventListener('cart:updated', function() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
      bubbles: true
    }));
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

